import { EditAdditionalServiceT } from '../types/billing.types'

export const DISCOUNT_ENTITY_TYPES = [
    {
        id: 'Calculation',
        name: 'На накладную',
    },
    {
        id: 'Company',
        name: 'На компанию',
    },
]

export const DISCOUNT_UNIT_TYPES = [
    {
        id: 1,
        name: 'Сумма (тенге)',
    },
    {
        id: 2,
        name: 'Процент',
    },
]

export const BILLING_TARIFF_TYPES = [
    {
        id: 1,
        name: 'Стандартный',
    },
    {
        id: 2,
        name: 'Индивидуальный',
    },
    {
        id: 3,
        name: 'Уникальный',
    },
]

export const BILLING_TARIFF_TYPES_EXTENDED = [
    {
        id: 1,
        name: 'Стандартный',
    },
    {
        id: 2,
        name: 'Индивидуальный',
    },
    {
        id: 3,
        name: 'Уникальный',
    },
    {
        id: 7,
        name: 'Стандартный 2025'
    }
]

export const UNIT_IDS_1 = [
    'insminPrice',
    'unloadPrice',
    'packPrice',
    'orderPrice',
    'minInsCheckPrice',
]

export const UNIT_IDS_3 = ['cubSize', 'overloadWeight']

export const INDIVIDUAL_PERCENT_LIST = [
    'fuelPercent',
    'inscostPercent',
    'regionalCoefficient',
    'selfDeliveryPercent',
    'pickupPercent',
    'distributionCenterDiscount',
]

export const INDIVIDUAL_PRICE_LIST = [
    'insminPrice',
    'unloadPrice',
    'packPrice',
    'orderPrice',
    'minInsCheckPrice',
]

export const OVERLOAD_WEIGHT_TYPES = [
    { id: 1, name: 1 },
    { id: 2, name: 2 },
    { id: 5, name: 5 },
    { id: 10, name: 10 },
]

export const INDIVIDUAL_ADDITIONAL_SERVICES = [
    {
        name: 'soft_package',
        price: 7000,
        minValue: 1,
        unitId: 3,
    },
    {
        name: 'grid',
        price: 10000,
        minValue: 1,
        unitId: 3,
    },
    {
        name: 'loader',
        price: 3000,
        minValue: 2,
        unitId: 4,
    },
    {
        name: 'pallet',
        price: 5000,
        minValue: 1,
        unitId: 3,
    },
    {
        name: 'hydraulic_trolley',
        price: 2500,
        minValue: 2,
        unitId: 4,
    },
]

export const BILLING_EDIT_ADDITIONAL_SERVICES: EditAdditionalServiceT[] = [
    {
        code: 'soft_package',
        value: 0,
        duration: 0,
        costPerHour: 0,
        costTotal: 0,
        paidPricePerHour: 0,
        paidPriceTotal: 0,
    },
    {
        code: 'grid',
        value: 0,
        duration: 0,
        costPerHour: 0,
        costTotal: 0,
        paidPricePerHour: 0,
        paidPriceTotal: 0,
    },
    {
        code: 'loader',
        value: 0,
        duration: 0,
        costPerHour: 0,
        costTotal: 0,
        paidPricePerHour: 0,
        paidPriceTotal: 0,
    },
    {
        code: 'pallet',
        value: 0,
        duration: 0,
        costPerHour: 0,
        costTotal: 0,
        paidPricePerHour: 0,
        paidPriceTotal: 0,
    },
    {
        code: 'hydraulic_trolley',
        value: 0,
        duration: 0,
        costPerHour: 0,
        costTotal: 0,
        paidPricePerHour: 0,
        paidPriceTotal: 0,
    },
    {
        code: 'manipulator',
        value: 0,
        duration: 0,
        costPerHour: 0,
        costTotal: 0,
        paidPricePerHour: 0,
        paidPriceTotal: 0,
    },
    {
        code: 'crane',
        value: 0,
        duration: 0,
        costPerHour: 0,
        costTotal: 0,
        paidPricePerHour: 0,
        paidPriceTotal: 0,
    },
]

export const BILLING_EDIT_ADDITIONAL_SERVICES_LIST = [
    {
        code: 'soft_package',
        name: 'Мягкая упаковка',
    },
    {
        code: 'grid',
        name: 'Обрешетка',
    },
    {
        code: 'loader',
        name: 'Грузчики',
    },
    {
        code: 'pallet',
        name: 'Паллета',
    },
    {
        code: 'hydraulic_trolley',
        name: 'Рохля',
    },
    {
        code: 'manipulator',
        name: 'Манипулятор',
    },
    {
        code: 'crane',
        name: 'Кран',
    },
]
